import { DeeplinksFactory } from './deeplinks/deeplinks.factory';

window.addEventListener('load', () => {
    new DeeplinksFactory().initialize();
});
